<template>
  <div class="">
    <!--内容-->
    <div class="content mt10">
      <div class="table-wrap">
        <el-table size="small" ref="table" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <!-- <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column> -->
          <el-table-column prop="form_id" label="ID" width="80" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="name" label="名称" width="120"></el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="intro" label="说明">
            <template slot-scope="scope">
              <span class="text-ellipsis-2">{{ scope.row.intro }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="60" align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.status == 1">开放</span>
              <span class="gray9" v-else>不开放</span>
            </template>
          </el-table-column>
          
          <el-table-column prop="name" label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="openPopup('edit', scope.row)" type="text" size="small">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--编辑-->
    <Edit v-if="show_popup['edit']" :open_edit="show_popup['edit']" :type="type" :input_type="input_type" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>
<script>
  import FormApi from '@/api/study/form.js';
  import Edit from './part/Edit.vue';
  import qs from 'qs';
  export default {
    components: {
      Edit,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formSearch: {
          type: '',
          name: '',
          input_type: '',
          status: '',
          is_detail: '',
          is_contrast: '',
          create_time: '',
        },
        /*弹窗*/
        show_popup: {
          add: false,
          edit: false,
          batch: false,
        },
        /*选中的对象*/
        selectModel:{},
        input_type:[],
        multipleSelection: [],
        ids: [],
        type: [],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formSearch, params);

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
      getRowKey (row) {
        return row.field_id;
      },
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
        this.ids = [];
        val.forEach(e => {
          this.ids.push(e.field_id);
        });
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formSearch;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        FormApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.input_type = data.input_type;
          self.type = data.category;
          self.totalDataNumber = data.list.total;
        }).catch(error => {
          self.loading = false;
        });
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            CustomFieldApi.del({field_id: row.field_id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formSearch;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if (item) this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      },

    }
  };
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/study/custom/form/index.vue